<ion-content class="md-page md-padded ly-col" *ngIf="userService.currentUser">
  <ng-container *ngIf="banners && banners.length && !bannerDismissed && isDesktop">
    <div class="banner ion-margin-bottom">
      <div class="banner-text">
        <h2>{{ "workspace.dashboard.banner.title" | translate }}</h2>
        <h6>{{ "workspace.dashboard.banner.message" | translate }}</h6>
        <ion-row *ngFor="let banner of banners" class="banner-text">
          <ion-text *ngIf="banner.text" [innerHTML]="banner.text" class="inner-banner"> </ion-text>
        </ion-row>
      </div>
      <div class="banner-button">
        <ion-row>
          <ion-button
            fill="fill"
            shape="round"
            class="button-icon ion-no-margin"
            color="primary"
            (click)="dismissBanner()"
          >
            <ion-icon slot="icon-only" name="close"> </ion-icon>
          </ion-button>
        </ion-row>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!isAdmin">
    <page-title icon="bar-chart-outline" title="workspace.dashboard.titles.netSocialOverview">
    </page-title>
    <ion-row class="ion-margin-top ion-padding-top overview flex-no-wrap">
      <pending-posts-manager class="ion-margin-end"></pending-posts-manager>
      <ion-button
        class="create-post ion-no-margin"
        (click)="createPost()"
        [disabled]="accountsLoading"
      >
        <div class="ly-col ion-align-items-center ion-margin">
          <ion-icon
            name="add-circle-outline"
            size="large"
            class="ion-margin-bottom"
            *ngIf="!accountsLoading"
          >
          </ion-icon>
          <ion-spinner *ngIf="accountsLoading" class="ion-margin-bottom"> </ion-spinner>
          {{"workspace.dashboard.buttons.createPost" | translate}}
        </div>
      </ion-button>
      <user-rank class="ion-margin-start"></user-rank>
    </ion-row>
  </ng-container>

  <ion-row
    class="ion-justify-content-between title-row-performance"
    [class.title-row-performance-admin]="isAdmin"
  >
    <page-title
      icon="analytics-outline"
      [title]="'workspace.dashboard.titles.'+performanceView+'Performance'"
      class="ion-margin-vertical ion-padding-vertical"
    >
    </page-title>
    <div class="ion-padding-top">
      <ion-item>
        <ion-select
          (ionChange)="
              selectedPeriod = $any($event).detail.value
            "
          [value]="selectedPeriod"
          [interfaceOptions]="{
            size: 'auto',
            alignment: 'start'
          }"
        >
          <ion-select-option *ngFor="let period of periodOptions" [value]="period">
            {{ period.toString() | translate }} Days
          </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item class="ion-margin-start">
        <ion-select
          (ionChange)="selectedView = $any($event).detail.value"
          [value]="selectedView"
          [interfaceOptions]="{
            size: 'auto',
            alignment: 'start'
          }"
          class="ion-text-capitalize"
        >
          <ion-select-option
            *ngFor="let view of viewOptions"
            [value]="view"
            class="ion-text-capitalize"
          >
            {{ view | translate }}
          </ion-select-option>
        </ion-select>
      </ion-item>
    </div>
  </ion-row>
  <ion-row class="performance">
    <performance-chart
      class="ion-margin-end"
      [showSpanSelector]="true"
      [startDate]="dashboardStartDate"
      [endDate]="dashboardEndDate"
      [hidePeriod]="true"
      [hideView]="true"
      [selectedView]="$any(selectedView)"
    >
    </performance-chart>
    <leaderboard-list
      class="flex"
      *ngIf="!isAdmin"
      joyrideStep="leaderboard"
      [title]="'workspace.dashboard.tour.leaderboard.title' | translate"
      [text]="'workspace.dashboard.tour.leaderboard.body' | translate"
      [startDate]="dashboardStartDate"
      [endDate]="dashboardEndDate"
    >
    </leaderboard-list>
    <netsocial-insights [class.ion-margin-start]="!isAdmin" class="flex" *ngIf="isDesktop">
    </netsocial-insights>
    <div *ngIf="isAdmin && isDesktop" class="ly-col ion-margin-start flex quick-links">
      <page-title
        icon="flash"
        title="workspace.dashboard.titles.quickLinks"
        class="ion-margin-vertical ion-padding-vertical ion-align-self-start"
      >
      </page-title>
      <ng-container *ngFor="let link of quickLinks">
        <ion-button
          class="quick-link"
          [ngClass]="{'desktop-create-post-button': link.icon === 'add-circle'}"
          *ngIf="link.all || (
              (link.onlyMyself && !contextOwner) || !link.onlyMyself) && 
              (
                (link.agency && contextOwner?.agency === '1') || 
                (!link.agency && contextOwner?.agency !== '1')
                )"
          [disabled]="(link.createPost && accountsLoading)"
          [routerLink]="link.routerLink ? [link.routerLink] : []"
          (click)="link.click ? link.click() : undefined"
        >
          <ion-row
            class="ion-justify-content-start flex ion-align-items-center flex-no-wrap text-ellipse"
          >
            <ion-icon [name]="link.icon" class="ion-margin-end flex-none"> </ion-icon>
            {{link.text | translate}}
          </ion-row>
          <ion-icon [name]="link.iconEnd" *ngIf="link.iconEnd" class="ion-margin-start"> </ion-icon>
        </ion-button>
      </ng-container>
    </div>
  </ion-row>

  <ng-container *ngIf="isAdmin && contextOwner?.agency !== '1'">
    <performance-grid
      joyrideStep="performance"
      [title]="'workspace.dashboard.tour.performance.title' | translate"
      [text]="'workspace.dashboard.tour.performance.body' | translate"
      [showHeader]="false"
      [period]="selectedPeriod"
      [view]="selectedView"
    >
    </performance-grid>
    <!-- Analyze Button remove -->
    <ion-row class="ion-justify-content-end ion-margin-top">
      <ion-button [routerLink]="['/workspace/analyze']">
        {{"components.performanceChart.buttons.viewAnalytics" | translate}}
      </ion-button>
    </ion-row>

    <ion-row class="title-row-leaderboard ion-margin-top">
      <page-title
        icon="trophy"
        title="workspace.dashboard.titles.leaderboard"
        class="ion-margin-vertical ion-padding-vertical"
      >
      </page-title>
      <div class="ion-padding-top">
        <ion-item>
          <ion-select
            (ionChange)="
              selectedPeriod = $any($event).detail.value
            "
            [value]="selectedPeriod"
            [interfaceOptions]="{
              size: 'auto',
              alignment: 'start'
            }"
          >
            <ion-select-option *ngFor="let period of periodOptions" [value]="period">
              {{ period.toString() | translate }} Days
            </ion-select-option>
          </ion-select>
        </ion-item>
      </div>
    </ion-row>

    <leaderboard-viewer
      joyrideStep="leaderboard"
      [title]="'workspace.dashboard.tour.leaderboard.title' | translate"
      [text]="'workspace.dashboard.tour.leaderboard.body' | translate"
      [startDate]="dashboardStartDate"
      [endDate]="dashboardEndDate"
      [hidePaging]="true"
    >
    </leaderboard-viewer>

    <ion-row class="ion-justify-content-end ion-margin-top">
      <ion-button [routerLink]="['/workspace/leaderboard']">
        {{"workspace.dashboard.buttons.fullLeaderboard" | translate}}
      </ion-button>
    </ion-row>
  </ng-container>

  <ng-container>
    <div [hidden]="contextOwner?.agency === '1'">
      <page-title
        icon="time"
        [title]="('workspace.dashboard.titles.' + (contextOwner ? 'companyCalendar' : 'yourCalendar')) | translate: { company: contextOwner?.name }"
        class="ion-margin-vertical ion-padding-top"
      >
      </page-title>

      <post-calendar
        viewFormat="weekdays"
        [stretch]="false"
        [range]="{ start: startDate, end: endDate }"
        [limitToRange]="true"
        [height]="300"
        [teamview]="(userService.currentUser?.isAgency || !contextOwner) ? undefined : 1"
      >
      </post-calendar>

      <ion-row class="ion-margin-top ion-padding-top">
        <ion-button [routerLink]="['/workspace/queue']">
          <ion-icon name="calendar" slot="start"></ion-icon>
          {{"workspace.dashboard.buttons.viewFullCalendar" | translate}}
        </ion-button>
      </ion-row>

      <ion-row class="title-row-top-posts ion-margin-top">
        <page-title
          icon="list"
          [title]="'workspace.dashboard.titles.' + (userService.currentUser?.isAdmin ? 'topPosts' : 'companyTopPosts')"
          class="ion-margin-vertical ion-padding-vertical"
        >
        </page-title>
        <div class="ion-padding-top">
          <ion-item>
            <ion-select
              (ionChange)="
                selectedPeriod = $any($event).detail.value
              "
              [value]="selectedPeriod"
              [interfaceOptions]="{
                size: 'auto',
                alignment: 'start'
              }"
            >
              <ion-select-option *ngFor="let period of periodOptions" [value]="period">
                {{ period.toString() | translate }} Days
              </ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </ion-row>

      <post-list
        type="top-post"
        [disabledOverflow]="true"
        [hideGrouping]="true"
        [scope]="'team'"
        [startDate]="dashboardStartDate"
        [endDate]="dashboardEndDate"
        [editing]="false"
      >
      </post-list>
    </div>
  </ng-container>
</ion-content>
<div *ngIf="isAdmin && canPost && !isDesktop">
  <ion-fab class="mobile-create-post-button" vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button>
      <ion-icon name="flash"></ion-icon>
    </ion-fab-button>
    <ion-fab-list side="top">
      <ion-fab-button (click)="openHelpCenter()">
        <ion-icon name="help-circle"></ion-icon>
      </ion-fab-button>
      <ion-fab-button [routerLink]="'/workspace/queue/pending'">
        <ion-icon name="alert-circle"></ion-icon>
      </ion-fab-button>
      <ion-fab-button [routerLink]="'/workspace/content'">
        <ion-icon name="images"></ion-icon>
      </ion-fab-button>
      <ion-fab-button (click)="createPost()">
        <ion-icon name="add-circle"></ion-icon>
      </ion-fab-button>
    </ion-fab-list>
  </ion-fab>
</div>
